var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-icon',{staticClass:"my-3 mr-3",attrs:{"color":hover ? _vm.highlightColor : _vm.baseColor,"x-large":""},on:{"click":_vm.openLink}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }